import config from '../config'

const CONFIG_FILE = 'custom-categories-config.json'
const CONFIG_CDN_BASE = 'https://arenacloud.cdn.arkadiumhosted.com'

export function getEventCategoryConfigCdnUrl () {
  const isLive = process.env.NODE_ENV === 'live' || process.env.NODE_ENV === 'feature-live'
  const container = isLive ? 'arenaxstorage-blob' : 'arenaxstoragedev-blob'
  return `${CONFIG_CDN_BASE}/${container}/arenax-index/_arena-shared-content_/ark-event-category/${CONFIG_FILE}`
}

export class EventCategoryService {
  constructor(msalOrCtx) {
    if (msalOrCtx && (msalOrCtx.msal || msalOrCtx.$msal)) {
      this.msal = msalOrCtx.msal || null
      this.$msal = msalOrCtx.$msal || null
    } else {
      this.msal = msalOrCtx
      this.$msal = null
    }
    this.apiUrl = config.apiUrl
  }

  async handleResponse(res) {
    if (res.status >= 200 && res.status < 300) {
      const contentType = res.headers.get('content-type')
      const contentLength = res.headers.get('content-length')
      if (res.status === 204 || contentLength === '0') return null
      if (!contentType || !contentType.toLowerCase().startsWith('application/json')) {
        try {
          const text = await res.text()
          return text || null
        } catch (_) {
          return null
        }
      }
      try {
        return await res.json()
      } catch (e) {
        try {
          const text = await res.text()
          return text || null
        } catch (_) {
          return null
        }
      }
    }

    if (res.status === 401) {
      try {
        if (this.$msal && typeof this.$msal.refreshToken === 'function') {
          await this.$msal.refreshToken()
        }
        const retryRes = await fetch(res.url, { method: res.method || 'GET', headers: this.getHeaders() })
        return this.handleResponse(retryRes)
      } catch (refreshError) {
        if (this.$msal && typeof this.$msal.signIn === 'function') {
          await this.$msal.signIn()
        }
        throw new Error('Authentication required')
      }
    }

    const isJson = res.headers.get('content-type')?.toLowerCase().startsWith('application/json')
    if (isJson) {
      return res.json().then(body => Promise.reject(body))
    }
    const text = await res.text()
    return Promise.reject(text)
  }

  getHeaders() {
    const token = this.msal?.idToken
    if (!token) {
      throw new Error('No authentication token available')
    }
    return { 'Authorization': `Bearer ${token}` }
  }

  async loadConfigFromCdn () {
    const url = `${getEventCategoryConfigCdnUrl()}?t=${Date.now()}`
    const res = await fetch(url)
    if (!res.ok) {
      throw new Error(`CDN config not found (${res.status})`)
    }
    return res.json()
  }

  async loadConfig () {
    try {
      const url = `${this.apiUrl}/CustomCategoryConfig`
      const res = await fetch(url, { headers: this.getHeaders() })
      return await this.handleResponse(res)
    } catch (apiError) {
      console.warn('Failed to load custom categories config from API, falling back to CDN:', apiError)
    }

    return this.loadConfigFromCdn()
  }

  async saveConfig(formData) {
    const url = `${this.apiUrl}/CustomCategoryConfig`
    const headers = this.getHeaders()
    const res = await fetch(url, { method: 'POST', headers, body: formData })
    return this.handleResponse(res)
  }
}


